import styles from "./Home.module.css";
import handleEmailClick from "../../Utils/Utils.js";
import Page from "../../Components/Page/Page.js";

function Home() {
  return (
    <Page>
      <div className={styles.intro}>
        <div className={styles.introText}>
          <p>
            We have been working with straw for many years. Straw work is an
            ancient craft with traditions reaching across the globe. Our
            particular interest is with corn dollies, Swiss straw work and straw
            marquetry. In particular we enjoy bringing a contemporary twist to
            traditional designs. Working with a natural product allows creative
            expression. It is a low impact, sustainable craft.
          </p>
          <p>
            Straw craft is currently listed as endangered by Heritage Crafts. We
            wish to promote the craft through workshops, which can be tailored
            to suit complete beginners. We aim to bring a mindful experience to
            the workshops and events with which we’re involved.
          </p>
          <p>Ian & Emma Speechley</p>
          <p>
            Contact by email:{" "}
            <span onClick={handleEmailClick} className={styles.email}>
              wheatearstraw@gmail.com
            </span>
          </p>
          <p>
            Find us on instagram:{" "}
            <a
              href="https://www.instagram.com/wheatear_strawcraft"
              className={styles.email}
              target="_blank"
              rel="noopener noreferrer"
            >
              @wheatear_strawcraft
            </a>
          </p>
        </div>
        <img
          src={
            "https://strawcraft.s3.eu-west-2.amazonaws.com/thumbnail_image0.webp"
          }
          alt={`Emma & Ian`}
          className={styles.image}
        />
      </div>
    </Page>
  );
}

export default Home;
